/** RP `/api/v2/regions/region/` `type` — aligned with mono `RegionType`. */
export enum RpRegionType {
    VOIVODESHIP = 1,
    AGGREGATION = 2,
    COUNTY = 3,
    CITY = 4,
    TOWN = 5,
    DISTRICT = 6,
    NEIGHBORHOOD = 7
}

/** City / town: fetch district children via `parent={id}&type=6`. */
export const isRpRegionDistrictParentType = (type: number): boolean =>
    type === RpRegionType.CITY || type === RpRegionType.TOWN;
